module.exports = __webpack_public_path__ + "img/livetihavet_logo_vit.4585ed3b.svg";